<div mat-dialog-content class="container">
  <div class="headline" translate>SIGNUP_SUCCESS.TITLE</div>
  <div class="content">
    <span translate>SIGNUP_SUCCESS.INSTRUCTIONS</span>
  </div>
  <div mat-dialog-actions>
    <button mat-stroked-button (click)="closeDialog()" cdkFocusInitial>
      <span translate>LABEL.OKAY</span>
    </button>
    <a mat-flat-button (click)="closeDialog()" routerLink="/login" color="primary">
      <span translate>SIGNUP_SUCCESS.BUTTON</span>
    </a>
  </div>
</div>
